<template>
    <div>
        <h6>＜CP概要＞</h6>
        <div class="d-flex" style="gap: 1rem">
            <div style="width: 45%">
                <div class="d-flex">
                    <div class="bg-color2 p-1" style="min-width: 150px">キャンペーン名</div>
                    <div class="p-1">{{ detailBeginForDocument.name }}</div>
                </div>
                <div class="d-flex">
                    <div class="bg-color2 p-1" style="min-width: 150px">顧客様情報</div>
                    <div class="p-1">
                        {{ detailBeginForDocument.clients_formatted
                        }}{{ detailBeginForDocument.agencies_formatted ? '/' + detailBeginForDocument.agencies_formatted : '' }}
                    </div>
                </div>
                <div class="d-flex">
                    <td colspan="1" class="bg-color2 p-1" style="min-width: 150px">キャンペーン期間</td>
                    <div class="p-1">
                        {{ formatDateTimeJapanese(detailBeginForDocument.campaign_start_date)
                        }}{{
                            detailBeginForDocument.campaign_end_date ? '～' + formatDateTimeJapanese(detailBeginForDocument.campaign_end_date) : ''
                        }}
                    </div>
                </div>
            </div>
            <div>
                <div class="d-flex">
                    <div class="bg-color2 p-1" style="min-width: 150px">CPサイト・CPツイート</div>
                    <div class="p-1">{{ detailBeginForDocument.url }}</div>
                </div>
                <div class="d-flex">
                    <div class="bg-color2 p-1" style="min-width: 150px">ディレクション担当</div>
                    <div class="p-1">
                        {{ formatPersonnelDisplay(detailBeginForDocument.person_in_charge, detailBeginForDocument.responsible_sub_persons) }}
                    </div>
                </div>
                <div class="d-flex">
                    <div class="bg-color2 p-1" style="min-width: 150px">営業担当</div>
                    <div class="p-1">{{ detailBeginForDocument.sale_staff ? detailBeginForDocument.sale_staff.name : '' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatDateTimeJapanese, formatPersonnelDisplay } from '@/views/pages/require/handlers';

export default {
    name: 'InfoCampaign',
    props: {
        detailBeginForDocument: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        formatDateTimeJapanese,
        formatPersonnelDisplay
    }
};
</script>

<style lang="scss" scoped></style>
